import { useNavigate } from "react-router-dom";

const BlogCard = ({ blog }) => {
  const navigate = useNavigate();
  return (
    <div className="group h-full flex flex-col bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition duration-300">

      {/* Content */}
      <div className="p-5 flex flex-col flex-grow">

        {/* Category + Date */}
        <div className="flex justify-between text-lg text-gray-400">
          <span className="text-pink-400">
            {blog.category}
          </span>
          <span>{blog.date}</span>
        </div>

        {/* Title */}
        <h3 className="text-black text-2xl font-poppins leading-snug transition mt-3 line-clamp-2 min-h-[64px]">
          {blog.title}
        </h3>

        {/* Description */}
        <p className="text-gray-700 text-lg leading-8 line-clamp-5 mt-4">
          {blog.description}
        </p>

        {/* CTA — pushed to the bottom no matter how tall the content above is */}
        <button
          onClick={() => navigate(`/blog/${blog.id}`)}
          className="text-pink-400 font-medium hover:underline mt-auto pt-4 text-left"
        >
          Read More →
        </button>
      </div>
    </div>
  );
};
export default BlogCard;